<template>
<!--  内容发布新编-->
  <div id="ContentReleaseList">
    <div v-show="showModel.model2">
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div style="width: auto">
            <p v-if="messageState === 20 || messageState === 30">内容审批</p>
            <p v-else class="font16">{{returnTopName()}}</p>
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <!-- 图文消息 -->
        <div v-if="postData.pushtypeId === 3">
          <div class="releLeft">
            <div>
              <nav class="m_l_10 m_b_5"><i class="VioletDot"></i><abbr class="font16">内容预览</abbr></nav>
              <p style="padding-left: 30px;z-index: 1" class="m_t_10 p_r">
                <span style="margin-right: 20px">链接:</span>
                <span v-if="contentDto.id">{{returnUrl}}</span>
                <!-- <input style="width: 70%" id="copyUrl" class="allInput" v-if="contentDto.id" :value="returnUrl" readonly="readonly" type="text">-->
                <!-- <button v-if="contentDto.id" @click="copyUrl" class="redButton">复制</button>-->
              </p>
              <div class="p_r">
                <img src="../../../assets/phtone1.png" width="100%" style="margin: 5% 0 0 0;margin-top: -10%; "/>
                <div style="margin-top: -10%" class="p_a contentPreview">
                  <nav class="d_flex font24"><span class="c_p">×</span><span class="c_p">···</span></nav>
                  <div  style="overflow: hidden">
                    <nav class="arciNav">
                      <p class="font16 f_w">{{contentDto.title}}</p>
                      <span class="colorZh">{{contentDto.contentEditor}} {{contentDto.publishDate}}</span>
                    </nav>
                    <div class="m_t_10" style="text-align: left!important;white-space: normal;word-break: normal;" v-html="contentDto.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="releRight">
            <section style="background-color: #F6F6F6;padding: 5% 0;border-radius: 5px;">
              <div style="position: relative;">
                <div class="move-btn" v-if="allRightDraftList.length > 0 && allRightDraftList[0].fileID">
                  <i class="icon iconfont iconshang-copy enable-move disable-move"></i>
                  <i class="icon iconfont iconup enable-move" style="margin-top: 5px;" :class="{'disable-move': (allRightDraftList.length == 1 || messageState == '已推送')}" @click="moveDown(allRightDraftList[0], 0)"></i>
                </div>
                <div v-if="allRightDraftList.length > 0 && allRightDraftList[0].fileID" class="c_p p_r addReleRightBody" style="height: 217px;position: relative;" @click="chooseRightLi(allRightDraftList[0])" :class="[allRightDraftList[0].checked ? 'onContentSelect' : '', allRightDraftList[0].recall ? 'liCover' : '']">
                  <img style="width: 100%;height: 100%" :src="baseUrl + '/api/Article/file/' + allRightDraftList[0].fileID">
                  <i class="icon iconfont iconguanbi1 p_a colorCH" style="top: -10px;right: -10px;z-index: 10;font-size: 16px;display: none" @click="removeRightLi(0)"  v-if="(messageState === 10 || messagePublishId === 0)"></i>
                  <p class="p_a colorWhite font16 NoWrap t_l" style="bottom: 8%;left:5%;width: 90%"><span>{{allRightDraftList[0].title}}</span></p>
                  <button class="cancelButtonTwo p_a" style="padding:6px; top: 6px;right: 6px" v-if="!allRightDraftList[0].recall && postData.id && $childMenu.indexOf('文章手动下架') >= 0" @click="toRecall(allRightDraftList[0])">下架</button>
                </div>
                <div class="addReleRightBodyTwo" v-else>
                  <div @click="addNewContent"><i class="icon iconfont icontianjia"></i></div>
                </div>
              </div>
              <div class="releLine"></div>
              <div class="addNewBody">
                <ul>
                  <li :key="index" v-for="(item, index) in allRightDraftList" v-if="index > 0" style="position: relative;" :class="item.recall ? 'liCover' : ''">
                    <div class="list-item" :class="item.checked ? 'onContentSelect' : ''" @click="chooseRightLi(item)">
                      <div class="split_8_2" style="width: calc(100% - 70px)">
                        <div class="NoWrap">{{item.title}}</div>
                        <div class="t_c"><button class="cancelButtonTwo" style="padding:6px" v-if="!item.recall && postData.id && $childMenu.indexOf('文章手动下架') >= 0" @click="toRecall(item)">下架</button></div>
                        <!-- <p class="NoWrap">{{item.detailInfo.summaryCN}}</p>-->
                      </div>
                      <div style="width: 50px;height: 50px">
                      <img v-if="item.fileID" :src="baseUrl + '/api/Article/file/' + item.fileID" width="50" height="50"/></div>
                      <i @click="removeRightLi(index)" class="icon iconfont iconguanbi1 p_a colorCH" style="display:none" v-if="(messageState === 10 || messageState === 0)"></i>
                    </div>
                    <div class="move-btn" style="right: -39px;">
                      <i class="icon iconfont iconshang-copy enable-move" :class="{'disable-move': messageState == '已推送'}" style="font-size:22px;" @click="moveUp(item, index)"></i>
                      <i class="icon iconfont iconup enable-move" :class="{'disable-move': (index == allRightDraftList.length - 1 || messageState == '已推送')}" style="font-size:22px;margin-top: 5px;" @click="moveDown(item, index)"></i>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="((messageState === 10 || messageState === 0) && allRightDraftList.length !== 0)" class="addReleRightBodyTwo m_t_10" style="padding: 5% 0;border:1px dashed #ee9900"  @click="addNewContent"><i class="icon iconfont icontianjia" style="color: #ee9900;font-size: 2em"></i></div>
            </section>
            <!-- <section class="releRightApproval" v-if="messageState && messageState !== 10">-->
            <!--  <nav class="m_l_10 m_b_10"><i class="VioletDot"></i><abbr class="font16">审批历史</abbr></nav>-->
            <!--    <ul style="padding: 0 5%">-->
            <!--        <li v-for="(item, index) in myApprovalList" :key="index" class="t_c">-->
            <!--            <div class="d_i">-->
            <!--                <span class="d_i triangle_text" :class="returnSeltColor2(item.color)">{{item.reviewNode}}</span><i :style="{'visibility': item.reviewNode !== '' && item.reviewNode !== null ? '' : 'hidden'}"  class="triangle-right" :class="returnSeltColor4(item.color)"></i>-->
            <!--              </div>-->
            <!--              <div class="d_i t_l textlist" :class="index !== 0 ? 'textlist2' : returnSeltColor(item.color)">-->
            <!--                 <p class="font18" :class="returnSeltColor3(item.color)">{{item.recordActionDesc}}</p>-->
            <!--                 <p :class="returnSeltColor3(item.color)">{{item.reviewer ? item.reviewer.name : ''}} {{item.reviewer ? item.reviewer.email : ''}}</p>-->
            <!--                 <p :class="returnSeltColor3(item.color)">{{item.reviewTime}}</p>-->
            <!--                 <div class="onlyRemarks" v-if="item.reviewComment">-->
            <!--                  <span>{{item.reviewComment}}</span>-->
            <!--                  <i class="triangle-up"></i>-->
            <!--               </div>-->
            <!--               <p v-for="(childrenitem, childindex) in item.otherReviewers" :key="childindex" class="colorGray m_t_5">{{childrenitem}}</p>-->
            <!--             </div>-->
            <!--          </li>-->
            <!--       </ul>-->
            <!--    </section>-->
          </div>
        </div>
        <!-- 纯文本-->
        <div v-if="postData.pushtypeId === 1">
          <textarea maxlength="200" placeholder="请输入文本内容" v-model="postData.content" class="allTextarea" style="width: calc(100% - 20px)" name="" id="" cols="30" rows="10"></textarea>
        </div>
        <!-- 图片-->
        <div v-if="postData.pushtypeId === 2">
          <input @change="clopuploadImg($event,2)" type="file" id="inFile" class="coverFile" accept="image/*"/>
          <label style="width: 564px;height: 240px" for="inFile">
            <div v-if="postData.fileid"><img :src="baseUrl + '/api/Article/file/' + postData.fileid + '?token=' + token" width="564" height="240" style="border-radius: 8px"/></div>
            <div v-else style="margin-top: 80px">
              <i class="icon iconfont iconshangchuan1 colorDH" style="font-size: 50px"></i>
              <p class="m_t_10 colorGray">点击上传图片</p>
              <p class="m_t_10 colorGray"> <span class="colorGray">请上传1068*455比例的图片</span></p>
            </div>
          </label>
        </div>
        <div>
          <ul class="allUL">
          <!--            <li><i class="colorRed">*</i><span>用户操作权限</span>-->
          <!--              <input v-model="postData.isCanComment" type="checkbox" class="allCheckbox" id="checkbox1" name="checkbox" :disabled="(messageState !== 10 && messageState !== 0)"/>-->
          <!--              <label for="checkbox1"></label><abbr>开启评论</abbr>-->
          <!--              <input v-model="postData.isCanLike" type="checkbox" class="allCheckbox" id="checkbox2" name="checkbox" :disabled="(messageState !== 10 && messageState !== 0)"/>-->
          <!--              <label for="checkbox2"></label><abbr>开启点赞</abbr>-->
          <!--              <input v-model="postData.isCanShare" type="checkbox" class="allCheckbox" id="checkbox3" name="checkbox" :disabled="(messageState !== 10 && messageState !== 0)"/>-->
          <!--              <label for="checkbox3"></label><abbr>开启转发</abbr>-->
          <!--              <input v-model="postData.hasWatermark" type="checkbox" class="allCheckbox" id="checkbox4" name="checkbox" :disabled="(messageState !== 10 && messageState !== 0)"/>-->
          <!--              <label for="checkbox4"></label><abbr>开启水印</abbr>-->
          <!--            </li>-->
            <li>
              <div style="display:inline-block;vertical-align: middle">
                <i class="colorRed">*</i><span>接收人</span>
              </div>
              <div v-if="messageState !== '已推送'" style="display:inline-block;vertical-align: middle;margin-left: 50px">
                <button class="redButtonTwo" @click="SendList('pub')">选择接收人</button>
              </div>
              <div style="width: 53%;max-height: 300px;white-space: normal;overflow: auto">
                <span style="display:inline-block;margin: 5px;padding: 8px 12px;border-radius: 5px;background-color: #fafafa" :key="index" v-for="(item, index) in postData.puspoelple">{{item.nickName || item.name}} <i  v-if="messageState !== '已推送'" @click="removepuspoelple(item, index)" class="m_l_5 font16 colorCH c_p" style="color:#ee1100">×</i></span>
              </div>
            </li>
            <!--            <li>-->
            <!--              <div style="display:inline-block;vertical-align: middle">-->
            <!--                <i class="colorRed">*</i><span>分组列表</span>-->
            <!--              </div>-->
            <!--              <div style="display: inline-block;vertical-align: middle;margin-left: 50px">-->
            <!--                <allSelect :width="'300'" :chooseData="groupList" :needReturn="'id'" :placeholder="'请选择分组（可多选）'" :matchValue="'name'" :showValue="'{{name}}'" :multiple="true" v-model="postData.groupIds">-->
            <!--                </allSelect>-->
            <!--              </div>-->
            <!--&lt;!&ndash;              <select v-model="postData.groupId" class="allSelect" style="width: 20%"  :disabled="(messageState !== 10 && messageState !== 0)">&ndash;&gt;-->
            <!--&lt;!&ndash;                <option value="" style="display: none" selected>请选择要发布的组</option>&ndash;&gt;-->
            <!--&lt;!&ndash;                <option :key="index" v-for="(item, index) in groupList" :value="item.id" selected>{{item.name}}</option>&ndash;&gt;-->
            <!--&lt;!&ndash;              </select>&ndash;&gt;-->
            <!--&lt;!&ndash;              <abbr class="allUnderlineJH m_l_10" @click="viewMen()">查看成员</abbr> <abbr class="allUnderlineJH m_l_10" @click="exportGroup()">导出</abbr>&ndash;&gt;-->
            <!--            </li>-->
            <li><span>发布时间</span>
              <input :disabled="messageState === '已推送'" v-model="postData.publishNow" :value="true" type="radio" class="allRadio" id="radio1" name="radio1"/>
              <label for="radio1"></label><abbr>立即推送</abbr>
              <input :disabled="messageState === '已推送'" v-model="postData.publishNow" :value="false" type="radio" class="allRadio" id="radio2" name="radio2"/>
              <label for="radio2"></label><abbr>定时推送</abbr>
              <cander :disabled="messageState === '已推送'" :minDate="$commonJs.todayDate" :noSec="true" v-if="!postData.publishNow" v-model="postData.pushPlanTime" :showTimePicker="true" :className="'allInput'" :placeholderName="'请选择时间'"  class="d_i m_l_10" style="vertical-align: middle"></cander>
            </li>
          </ul>
        </div>
        <div class="releLine" style="width: 100%"></div>
        <div class="t_r m_r_10 m_t_10">
          <button v-if="messageState !== '已推送' && $childMenu.indexOf('发布') >= 0" @click="saveContent" class="redButtonTwo">发布</button>
          <button v-if="messageState !== '已推送' && $childMenu.indexOf('发布测试消息') >= 0" class="redButtonTwo" @click="SendList('test')">发送测试消息</button>
          <button class="cancelButtonTwo" @click="allReturn">返回</button>
        </div>
        <!--        <div class="t_r m_r_10 m_t_10" v-else>-->
        <!--          <div class="t_r m_r_10 m_t_10" v-if="messageState === 20 || messageState === 30">-->
        <!--            <button v-if="messagePublishId !== 0 " class="redButtonTwo" @click="SendList()">发送测试消息</button>-->
        <!--            <button v-if="canProve" class="redButtonTwo" @click="selLaud">审批</button>-->
        <!--            <button class="cancelButtonTwo" @click="allReturn">返回</button>-->
        <!--          </div>-->
        <!--          <div class="t_r m_r_10 m_t_10" v-else>-->
        <!--            <button @click="saveContent" class="redButtonTwo" v-if="messageState !== 70 && messageState !== 21 && messageState !== 60">保存</button>-->
        <!--            <button class="redButtonTwo" @click="addNewMaterial" v-if="messageState === 70">保存为素材</button>-->
        <!--            <button v-if="(messagePublishId !== 0 || newMessagePublishId !== 0) && messageState !== 70 && messageState !== 21" class="redButtonTwo" @click="SendList()">发送测试消息</button>-->
        <!--            <button v-if="(messagePublishId !== 0 || newMessagePublishId !== 0) && messageState !== 70 && canProve && messageState !== 21" class="redButtonTwo" @click="SubmitList">提交审批</button>-->
        <!--            <button class="cancelButtonTwo" @click="allReturn">返回</button>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!--选择文章-->
      <model v-if="showModel.model1" :buttonType="0" :title="'选择文章'" :minWidth="'1000px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
        <div class="newSearch d_i m_t_10 m_b_10">
          <p class="d_i m_l_10">
            <input v-model="getDraftList.creator" class="allInput" type="text" placeholder="创建人">
          </p>
          <p class="d_i m_l_10">
            <input v-model="getDraftList.tags" class="allInput" type="text" placeholder="标签">
          </p>
          <p class="d_i m_l_10">
            <input v-model="getDraftList.title" class="allInput" type="text" placeholder="文章名称">
          </p>
          <p class="d_i m_l_10">
            <abbr class="d_i">
              <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="getDraftList.categoryId">
              </allSelect>
            </abbr>
          </p>
        </div>
        <div class="d_i m_l_10">
          <button class="redButton" @click="getmyDraftList(1, false)">
            <i class="icon iconfont iconsousuo"></i>
            <span>搜索</span>
          </button>
        </div>
        <div style="max-height: 400px;overflow: auto">
          <table cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr style="background-color: #FBFBFB;color: #797979">
              <th></th>
              <th>ID</th>
              <th>文章名称</th>
              <th class="t_c">文章类型</th>
              <th class="t_c">标签</th>
              <th class="t_c">分类</th>
              <th class="t_c">创建人</th>
            </tr>
            </thead>
            <tbody>
            <tr @click="selectIndex = index" :class="selectIndex === index ? 'choosed' : ''" :key="index" v-for="(item, index) in myDraftList">
              <td>
                <!--              <input type="radio" class="allRadio" id="radio3" name="radioMdole"/>-->
                <!--              <label for="radio3"></label>-->
              </td>
              <td>{{item.id}}</td>
              <td class="NoWrap" width="20%" style="max-width: 200px">{{item.title}}</td>
              <td class="t_c NoWrap" width="10%">{{item.articleType == 'F' ? '武田推文' : '腾讯推文'}}</td>
              <td class="t_c NoWrap" width="20%" style="max-width: 200px" >{{item.tags}}</td>
              <td class="t_c">{{item.categoryName}}</td>
              <td class="t_c">{{item.createName}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <page :size="5" v-on:on-getList="getmyDraftList($event, false)" :totalCount="myDrafttotalCount" :totalPage="myDrafttotalPage" :page="myDraftpage" :explain="0"></page>
      </model>
      <newUserPicker :pushType="postData.publishNow" :pushInfo="postData.puspoelple" :needGroup="true" :title="chooseType !== 'test' ? '选择接收人' : '发送测试消息'" v-on:choosedConfirm="confirUserPicker($event)" v-model="showModel.model4"></newUserPicker>
      <model v-if="showModel.model5" :buttonType="0" :title="'内容审批'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="MenconfirModel()">
        <div class="allSearch">
          <div class="t_c laudTop">
            <div :class="!newLaud ? '' : 'onlaud'" @click="selModelLaud(true)"><i class="icon iconfont iconchenggong"></i><abbr>审批通过</abbr></div>
            <div :class="!newLaud ? 'onlaud' : ''"  @click="selModelLaud(false)"><i class="icon iconfont iconshibai"></i><abbr>审批拒绝</abbr></div>
          </div>
          <div>
            <span style="width: 50px;" class="t_r m_r_10 d_i">备注：</span>
            <textarea class="allTextarea" style="width: calc(100% - 110px)"  v-model="newReview.reviewComment"></textarea>
          </div>
        </div>
      </model>
      <model v-if="showModel.model6" :buttonType="0" :title="'保存为素材'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="materialModel()">
        <div id="modelSwitah">
          <div>
            <p class="m_b_10"><i class="colorRed">*</i><span>请选择内容</span></p>
            <table cellspacing="0" class="allTable alltableHui">
              <thead>
              <tr>
                <th class="t_c">内容名称</th>
                <th class="t_c">权限</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="mateindex" v-for="(item, mateindex) in myDraftList">
                <td width="50%">
                  <input type="checkbox" class="allCheckbox" :id="'mateCheck' + mateindex" name="mateCheck" v-model="item.checked">
                  <label :for="'mateCheck' + mateindex" style="vertical-align: sub"></label><span>{{item.title}}</span>
                </td>
                <td width="50%" class="t_c">
                  <input type="radio" class="allRadio" :id="'mateRadio1' + mateindex" :name="'mateRadio1' + mateindex" :value="'AllUser'" v-model="item.materialScope">
                  <label :for="'mateRadio1' + mateindex" style="vertical-align: sub"></label><span style="vertical-align: middle">全体成员可见</span>
                  <input type="radio" class="allRadio" :id="'mateRadio2' + mateindex" :name="'mateRadio1' + mateindex" :value="'OnlyCreator'" v-model="item.materialScope">
                  <label :for="'mateRadio2' + mateindex" style="vertical-align: sub"></label><span>仅自己可见</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="newSearch m_t_10">
            <p>
              <span>素材标签</span><input type="text" class="allInput m_l_10" v-model="newTag" placeholder="请输入素材分类名称">
            </p>
          </div>
        </div>
      </model>
    </div>
    <!--    查看成员-->
    <div v-show="showModel.model3">
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div style="white-space: normal;width: auto">
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" placeholder="姓名" v-model="newDominList.name">
            </p>
            <p v-if="onSearch" style="vertical-align: middle">
              <allSelect :chooseData="allgender" :needReturn="'id'" :placeholder="'性别'" :matchValue="'name'" :showValue="'{{name}}'" v-model="newDominList.gender">
              </allSelect>
            </p>
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" placeholder="工作邮箱" v-model="newDominList.email">
            </p>
            <p  v-if="onSearch">
              <input @keyup.enter="getDominList(1)" class="allInput" type="text"  v-model="newDominList.company_Name" placeholder="分公司">
            </p>
            <p  v-if="onSearch">
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" v-model="newDominList.location" placeholder="所在地">
            </p>
            <p  v-if="onSearch">
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" v-model="newDominList.building_Long" placeholder="地址">
            </p>
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" v-model="newDominList.org_Acronym" placeholder="部门">
            </p>
            <p  v-if="onSearch" style="vertical-align: middle">
              <allSelect :chooseData="allcontent" :needReturn="'id'" :placeholder="'已关注'" :matchValue="'typeName'" :showValue="'{{typeName}}'" v-model="newDominList.IsAttention">
              </allSelect>
            </p>
          </div>
          <div style="width: auto">
            <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>
            <button class="redButton" @click="getDominList(1)">
              <i class="icon iconfont iconsousuo"></i>
              <span>搜索</span>
            </button>
            <button @click="clearPostData" class="cancelButtonTwo">
              清空
            </button>
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <div class="d_flex m_b_10">
          <div>查看成员</div>
          <div>
            <button class="cancelButtonTwo" @click="allTwoReturn">返回</button>
          </div>
        </div>
        <div>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>姓名</th>
              <th class="t_c">性别</th>
              <th>工作邮箱</th>
              <th>分公司</th>
              <th>所在地</th>
              <th>地址</th>
              <th>部门</th>
              <th class="t_c">已关注</th>
              <th class="t_c">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in myList" :key="index">
              <td width="5%" class="NoWrap" style="max-width: 30px" :title="item.name">{{item.name}}</td>
              <td width="5%" class="t_c NoWrap" :title="$commonJs.getGender(item.gender)">{{$commonJs.getGender(item.gender)}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.email">{{item.email}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.company_Name">{{item.company_Name}}</td>
              <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.location">{{item.location}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.building_Long">{{item.building_Long}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.org_Acronym">{{item.org_Acronym}}</td>
              <td width="5%" class="t_c">{{item.isAttention ? '是': '否'}}</td>
              <td width="5%" style="cursor: pointer;text-decoration:underline #408DEB;" class="colorBlue t_c" @click="viewUserList(item)">查看</td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getDominList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
      <model v-if="membershowModel" :buttonType="2" :title="'用户信息'" :minWidth="'800px'" v-on:on-cancel="cancelModel()">
        <div class="m_10">
          <div class="p_r">
            <div>
              <dl class="userInformation">
                <dd><span>姓名：</span><abbr>{{userDetails.name}}</abbr></dd>
                <dd><span>性别：</span><abbr>{{$commonJs.getGender(userDetails.gender)}}</abbr></dd>
                <dd><span>工作邮箱：</span><abbr>{{userDetails.email}}</abbr></dd>
                <dd><span>分公司：</span><abbr>{{userDetails.company_Name}}</abbr></dd>
                <dd><span>所在地：</span><abbr>{{userDetails.location}}</abbr></dd>
                <dd><span>地址：</span><abbr>{{userDetails.building_Long}}</abbr></dd>
                <dd><span>部门：</span><abbr>{{userDetails.org_Acronym}}</abbr></dd>
                <dd><span>职位：</span><abbr>{{userDetails.title}}</abbr></dd>
                <dt><span>企业微信ID:</span><abbr>{{userDetails.openId}}</abbr></dt>
                <dt><span>Device ID:</span><abbr><div style="margin-right: 5px;" v-for="(item, index) in userDetails.deviceIdList" :key="index" >{{item}}</div></abbr></dt>
                <dd><span>注册时间：</span><abbr>{{$commonJs.returnNewDate(userDetails.lastPasswordModificationTime)}}</abbr></dd>
                <dd><span>已关注：</span><abbr>{{userDetails.isAttention ? '是' : '否'}}</abbr></dd>
              </dl>
            </div>
          </div>
        </div>
      </model>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'ContentReleaseList',
  data () {
    return {
      allgender: [
        {
          id: -1,
          name: '未知'
        },
        {
          id: 0,
          name: '男'
        },
        {
          id: 1,
          name: '女'
        },
        {
          id: 2,
          name: '全部'
        }
      ],
      allcontent: [
        {
          id: '-1',
          typeName: '是否关注'
        },
        {
          id: 'true',
          typeName: '是'
        },
        {
          id: 'false',
          typeName: '否'
        }
      ],
      showContentName: this.$route.query.showContentName,
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      checkedMyDraft: false,
      newLaud: true,
      membershowModel: false,
      myList: [],
      userDetails: {},
      appList: [],
      onSearch: false,
      messagePublishId: parseInt(this.$route.query.id),
      messageState: this.$route.query.messageState ? this.$route.query.messageState : 0,
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      CNmode: true,
      selectIndex: '',
      contentDto: {
        url: '',
        detailInfo: {}
      },
      allRightDraftList: [],
      getDraftList: {
        status: 2,
        ContainsContentIds: [],
        MessagePublishId: parseInt(this.$route.query.id),
        ID: '',
        title: '',
        ContentTypeIds: this.$route.query.selectContentType,
        PageIndex: 1,
        PageSize: 5,
        IsContainsMapping: true,
        articleType: 'H' // 全图文 F全图文，H半图文
      },
      showModel: {
        model1: false,
        model2: true,
        model3: false,
        model4: false,
        model5: false,
        model6: false
      },
      postData: {
        content: '',
        groupIds: '',
        id: parseInt(this.$route.query.id),
        pushtypeId: parseInt(this.$route.query.pushType),
        pushtype: '',
        fileid: 0,
        contentTypeId: this.$route.query.selectContentType,
        isCanLike: false,
        pushTimeType: '',
        isCanComment: false,
        isCanShare: false,
        hasWatermark: false,
        publishNow: true, // 立即推送
        groupId: '',
        pushPlanTime: '',
        messageContentMappings: [],
        pushArticle: [],
        puspoelple: []
      },
      totalPage: 1,
      totalCount: 0,
      myDrafttotalPage: 1,
      myDrafttotalCount: 0,
      page: 1,
      myDraftpage: 1,
      myDraftList: [],
      groupList: [],
      newDominList: {
        domninId: 0,
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize,
        userType: 0,
        name: '',
        gender: 2,
        email: '',
        company_Name: '',
        location: '',
        building_Long: '',
        org_Acronym: '',
        IsAttention: '-1'
      },
      myApprovalList: [],
      newTag: '',
      chooseType: '',
      newMyDraf: [],
      newReview: {
        reviewAction: true,
        reviewComment: ''
      },
      showCander: false,
      newMessagePublishId: parseInt(this.$route.query.id),
      canProve: false,
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || [{id: 1, typeName: '测试类别'}],
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }]
    }
  },
  created () {
    this.searchCate = this.searchCate.concat(this.allcontent2)
    this.getGroupList()
    if (this.messagePublishId !== 0) {
      this.getDetail()
      // this.getReviewRecords()
      // this.$axiox.get('/api/content/publish/' + this.messagePublishId + '/canReview').then(p => {
      //   this.canProve = p.result
      // })
    }
  },
  mounted () {
    // this.$axiox.get('/api/SystemSetting/corpId')
  },
  computed: {
    returnUrl () {
      return 'https://' + window.location.host + '/mobileContent?id=' + this.contentDto.id + `&source=WY`
    }
  },
  methods: {
    toRecall(item) {
      console.log(item)
      this.$commonJs.doubleComfirm({
        content: '请确认是否下架',
        successFun: msg => {
          this.$axiox.get(`${this.$commonJs.returnQuery('/api/push/recall', {pushid: this.postData.id, articleId: item.id})}`).then( p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '下架成功',
              stayTime: 5
            })
            this.getDetail()
          } )
        },
        errorFun: msg => {
        }
      })

    },
    copyUrl () {
      let Url2 = document.getElementById('copyUrl')
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
    removepuspoelple (item, index) {
      this.postData.puspoelple.splice(index, 1)
    },
    clopuploadImg (e, num) {
      // 上传图片
      var file = e.target.files[0]
      // if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '提示',
      //     content: '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
      //     stayTime: 5
      //   })
      //   // alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
      //   return false
      // }
      // this.showClop = true
      // this.$nextTick(p => {
      //   var reader = new FileReader()
      //   reader.onload = (e) => {
      //     let data
      //     data = e.target.result
      //     if (typeof e.target.result === 'object') {
      //       // 把Array Buffer转化为blob 如果是base64不需要
      //       data = window.URL.createObjectURL(new Blob([e.target.result]))
      //     } else {
      //       data = e.target.result
      //     }
      //     if (num === 1) {
      //       this.option.img = data
      //     } else if (num === 2) {
      //       this.example2.img = data
      //     }
      //   }
      //   reader.readAsArrayBuffer(file)
      // })
      // // 转化为base64
      // // reader.readAsDataURL(file)
      // // 转化为blobcs
      this.signalUpload(file)
    },
    async signalUpload (e) {
      // let fileImg = e.target.files[0]
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.postData.fileid = await this.$commonJs.uploadFile(fileImg)
        // this.allspeakerRequestList.avatar = baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + this.avatarId
        // e.target.value = ''
        document.getElementById('inFile').value = ''
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    returnTopName () {
      if (this.messagePublishId === 0) {
        return '新建内容'
      } else {
        if (this.messageState === '已推送' || this.messageState === 21) {
          return '查看内容'
        } else {
          return '编辑内容'
        }
      }
    },
    returnSeltColor (type) {
      switch (type) {
        case 1:
          return 'colorY_blue'
        case 4:
          return 'colorY_yellor'
        case 3:
          return 'colorY_purple'
      }
      return 'colorY_blue'
    },
    returnSeltColor2 (type) {
      switch (type) {
        case 1:
          return 'back_colorBlue2'
        case 4:
          return 'back_colorYellow2'
        case 3:
          return 'back_colorPurple'
      }
      return 'back_colorBlue2'
    },
    returnSeltColor3 (type) {
      switch (type) {
        case 1:
          return 'colorBlue2'
        case 4:
          return 'colorYellow2'
        case 3:
          return 'colorPurple'
      }
      return 'colorBlue2'
    },
    returnSeltColor4 (type) {
      switch (type) {
        case 1:
          return 'border_leftBlue'
        case 4:
          return 'border_leftyellor'
        case 3:
          return 'border_leftpurple'
      }
      return 'border_leftBlue'
    },
    selModelLaud (type) {
      this.newLaud = type
      // this.newReview.reviewAction = type ? 'ContentOwner_Review_Approve' : 'ContentOwner_Review_Reject'
      this.newReview.reviewAction = type
    },
    // 获取的审批记录
    getReviewRecords () {
      this.$axiox.get('/api/content/publish/' + this.messagePublishId + '/reviewRecords').then(msg => {
        console.log(msg)
        this.myApprovalList = msg.result
      })
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    getDetail () {
      this.$axiox.get('/api/push/query/' + this.messagePublishId).then(p => {
        for (let i = 0; i < p.puspoelple.length; i++) {
          p.puspoelple[i].OpenID = p.puspoelple[i].openID
          p.puspoelple[i].openId = p.puspoelple[i].openID
          p.puspoelple[i].docName = p.puspoelple[i].nickName
          p.puspoelple[i].type = p.puspoelple[i].type
        }
        this.postData = {
          groupIds: '',
          id: parseInt(this.$route.query.id),
          pushtypeId: parseInt(this.$route.query.pushType),
          pushtype: p.pushtype,
          fileid: p.fileid,
          content: p.content,
          contentTypeId: this.$route.query.selectContentType,
          isCanLike: p.isCanLike,
          pushTimeType: p.pushTimeType,
          isCanComment: p.isCanComment,
          isCanShare: p.isCanShare,
          hasWatermark: false,
          publishNow: p.pushTimeType === '立即推送' ? true : false,
          groupId: '',
          pushPlanTime: p.pushPlanTime,
          messageContentMappings: [],
          pushArticle: p.pushArticle,
          puspoelple: p.puspoelple
        }
        // if (p.pushPlanTime !== '' && p.pushPlanTime !== null && p.pushPlanTime !== undefined) {
        //   // this.$set(this.postData, 'publishNow', false)
        //   this.postData.publishNow = false
        // }
        this.getAllContent(p)
        // else {
        //   // this.$set(this.postData, 'publishNow', true)
        //   this.postData.publishNow = true
        // }
        console.log(this.postData, 'postData----------99999999')
      })
    },
    async getAllContent (p) {
      this.allRightDraftList = []
      for (let i = 0; i < p.pushArticle.length; i++) {
        let contentde = await this.$axiox.asyncGet('/api/Article/' + p.pushArticle[i])
        contentde.content = contentde.content.replace(/&lt;iframe/g, '<iframe').replace(/&gt;&lt;\/iframe&gt;/g, '></iframe>').replace(/&lt;source/g, '<source').replace(/\/&gt;/g, '/>')
        console.log(contentde)
        // let data = {
        //   url: p.messageContentMappings[i].url,
        //   detailInfo: p.messageContentMappings[i].content
        // }
        this.allRightDraftList.push(contentde)
      }
      console.log(this.allRightDraftList)
      p.pushArticleMaps.forEach( m => {
        this.allRightDraftList.forEach( n => {
          if (m.aricleId === n.id){
            n.recall = m.recall
          }
        } )
      } )
      this.contentDto = this.allRightDraftList[0]
    },
    async saveContent () {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.puspoelple.length > 1) {
        if (data.pushtypeId === 3) {
          if (this.allRightDraftList.length === 0) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '请选择图文内容',
              stayTime: 5
            })
            return
          }
          // let hasVideo = false
          let array = []
          for (let i = 0; i < this.allRightDraftList.length; i++) {
            // if (this.allRightDraftList[i].content.indexOf('<video') >= 0) {
            //   hasVideo = true
            // }
            array.push(this.allRightDraftList[i].id)
          }
          let flag = await this.$axiox.asyncPost('/api/push/push/ishasvideo', array)
          if (flag) {
            if (data.publishNow) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '您所选择的内容中包含视频，请选择最少24小时之后推送',
                stayTime: 5
              })
              return
            }
            if (!data.publishNow && new Date(data.pushPlanTime).getTime() - new Date().getTime() < 24 * 60 * 60 * 1000) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '您所选择的内容中包含视频，请选择最少24小时之后推送',
                stayTime: 5
              })
              return
            }
          }
        }
        if (data.pushtypeId === 1) {
          if (data.content === '') {
            this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '请输入文本内容',
              stayTime: 5
            })
            return
          }
        }
        if (data.pushtypeId === 2) {
          if (!data.fileid) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '请上传图片',
              stayTime: 5
            })
            return
          }
        }
        data.pushtype = this.returnPushType(data.pushtypeId)
        let pushArticle = []
        for (let i = 0; i < this.allRightDraftList.length; i++) {
          pushArticle.push(this.allRightDraftList[i].id)
        }
        if (data.publishNow) {
          data.pushPlanTime = this.$commonJs.todayDate
        }
        data.pushTimeType = data.publishNow ? '立即推送' : '定时推送'
        if (!data.publishNow && !data.pushPlanTime) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择推送时间',
            stayTime: 5
          })
          return
        }
        if (!data.publishNow && new Date(data.pushPlanTime).getTime() < new Date().getTime()) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '不允许小于当前时间',
            stayTime: 5
          })
          return
        }
        data.fileid = parseInt(data.fileid)
        data.pushArticle = pushArticle
        console.log(data, 'data')
        console.log(this.allRightDraftList, 'this.allRightDraftList')
        if (data.id === 0) {
          this.$axiox.post('/api/push/add', data).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            this.$router.history.go(-1)
          })
        } else {
          this.$axiox.post('/api/push/update', data).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '更新成功',
              stayTime: 5
            })
            this.$router.history.go(-1)
          })
        }
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '推送最少选择2人',
          stayTime: 5
        })
      }
    },
    getGroupList () {
      let url = this.$commonJs.returnQuery('/api/Group/GetByName', {PageIndex: 1, PageSize: 9999})
      this.$axiox.getList(url).then(msg => {
        this.groupList = msg.data
      })
    },
    changeType (type) {
      this.CNmode = type
    },
    removeRightLi (index) {
      this.contentDto = {
        url: '',
        detailInfo: {}
      }
      this.allRightDraftList.splice(index, 1)
    },
    chooseRightLi (item) {
      if (item.checked) {
        item.checked = false
        this.contentDto = {
          url: '',
          detailInfo: {}
        }
      } else {
        for (let i = 0; i < this.allRightDraftList.length; i++) {
          this.allRightDraftList[i].checked = false
        }
        item.checked = true
        this.contentDto = JSON.parse(JSON.stringify(item))
      }
    },
    getmyDraftList (pageIndex, isMapping) {
      if (isMapping !== undefined) {
        this.getDraftList.IsContainsMapping = isMapping
      } else {
        this.getDraftList.IsContainsMapping = true
      }
      this.getDraftList.PageIndex = pageIndex
      // let data = []
      // for (let i = 0; i < this.allRightDraftList.length; i++) {
      //   data.push(this.allRightDraftList[i].detailInfo.id)
      // }
      // this.getDraftList.ContainsContentIds = data
      let url = this.$commonJs.returnQuery('/api/Article', this.getDraftList)
      this.$axiox.getList(url).then(msg => {
        this.myDraftList = msg.data
        this.myDraftpage = pageIndex
        this.myDrafttotalPage = Math.ceil(msg.total / this.getDraftList.PageSize)
        console.log(this.myDrafttotalPage)
        this.myDrafttotalCount = msg.total
        this.selectIndex = ''
        for (let i = 0; i < this.myDraftList.length; i++) {
          this.myDraftList[i]['checked'] = false
          this.myDraftList[i]['materialScope'] = 'AllUser'
        }
      })
    },
    addNewContent () {
      console.log('addNewContent')
      if (this.allRightDraftList.length < 8) {
        // ismapping默认条件未true
        this.getmyDraftList(1, false)
        this.showModel.model1 = true
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '内容最多添加8条',
          stayTime: 5
        })
      }
    },
    cancelModel () {
      this.showModel.model1 = false
      this.membershowModel = false
      this.showModel.model5 = false
      this.showModel.model6 = false
    },
    confirModel () {
      if (this.selectIndex !== '') {
        let id = this.myDraftList[this.selectIndex].id
        for (let i = 0; i < this.allRightDraftList.length; i++) {
          if (this.allRightDraftList[i].id === id) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '提示',
              content: '您已经添加过该内容',
              stayTime: 5
            })
            return
          }
        }
        this.$axiox.get('/api/Article/' + id).then(p => {
          p.checked = false
          console.log(p)
          this.allRightDraftList.push(p)
          this.showModel.model1 = false
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请先选择文章',
          stayTime: 5
        })
      }
    },
    viewMen () {
      if (this.postData.groupId === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请先选择分组!',
          stayTime: 5
        })
        return
      }
      this.showModel.model2 = false
      this.showModel.model3 = true
      this.getDominList(1)
    },
    // 查看成员
    getDominList (pageIndex) {
      this.newDominList.domninId = this.postData.groupId
      this.page = pageIndex
      this.newDominList.pageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.newDominList))
      if (data.IsAttention === '-1') {
        delete data['IsAttention']
      }
      let url = this.$commonJs.returnQuery('/api/Group/' + this.newDominList.domninId + '/Members', data)
      this.$axiox.get(url).then(msg => {
        this.myList = msg.result.items
        this.totalPage = Math.ceil(msg.result.totalCount / this.newDominList.pageSize)
        this.totalCount = msg.result.totalCount
      })
    },
    allTwoReturn () {
      this.showModel.model2 = true
      this.showModel.model3 = false
    },
    allReturn () {
      // this.$router.go(-1)
      this.$router.push({
        name: 'ContentRelease'
      })
    },
    // 查看用户信息
    viewUserList (object) {
      console.log(object)
      this.membershowModel = true
      this.userDetails = object
      this.$axiox.get('/api/user/' + object.id + '/apps').then(msg => {
        this.appList = msg.result
      })
    },
    // 审批
    MenconfirModel () {
      let url = '/api/content/publish/' + this.messagePublishId + '/review'
      this.$axiox.post(url, this.newReview).then(msg => {
        this.showModel.model5 = false
        this.$router.history.go(-1)
        window.sessionStorage.setItem('reflash', 'need')
      })
    },
    clearPostData () {
      this.newDominList.gender = 2
      this.newDominList.name = ''
      this.newDominList.email = ''
      this.newDominList.company_Name = ''
      this.newDominList.location = ''
      this.newDominList.building_Long = ''
      this.newDominList.org_Acronym = ''
      this.newDominList.IsAttention = '-1'
    },
    exportGroup () {
      if (this.postData.groupId === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请先选择分组!',
          stayTime: 5
        })
        return
      }
      let selectContentName = this.groupList.find(p => { return p.id === parseInt(this.postData.groupId) })
      console.log(selectContentName.name)
      var xmlResquest = new XMLHttpRequest()
      xmlResquest.open('GET', this.baseUrl + '/api/Group/' + this.postData.groupId + '/export?groupName=' + selectContentName.name, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('token'))
      xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = selectContentName.name + '.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      // this.$axiox.get('/api/Group/' + id + '/export?groupName=' + name).then(msg => {
      // })
      this.$commonJs.alertTips({
        type: 'success',
        title: '成功',
        content: '导出成功!',
        stayTime: 5
      })
    },
    SendList (type) {
      this.chooseType = type
      this.showModel.model4 = true
    },
    async confirUserPicker (e) {
      if (this.chooseType === 'test') {
        if (e.chooseUserList.length > 0) {
          let data = JSON.parse(JSON.stringify(this.postData))
          data.pushtype = this.returnPushType(data.pushtypeId)
          let emailList = []
          for (let i = 0; i < e.chooseUserList.length; i++) {
            e.chooseUserList[i].openID = e.chooseUserList[i].openId
            emailList.push(e.chooseUserList[i])
          }
          let pushArticle = []
          for (let i = 0; i < this.allRightDraftList.length; i++) {
            pushArticle.push(this.allRightDraftList[i].id)
          }
          if (data.publishNow) {
            data.pushPlanTime = this.$commonJs.todayDate
          }
          data.pushTimeType = data.publishNow ? '立即推送' : '定时推送'
          if (!data.publishNow && !data.pushPlanTime) {
            delete data['pushPlanTime']
          }
          data.fileid = parseInt(data.fileid)
          data.puspoelple = emailList
          data.pushArticle = pushArticle
          if (data.pushtypeId === 3) {
            if (this.allRightDraftList.length === 0) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '请选择图文内容',
                stayTime: 5
              })
              return
            }
            // let hasVideo = false
            // for (let i = 0; i < this.allRightDraftList.length; i++) {
            //   if (this.allRightDraftList[i].content.indexOf('<video') >= 0) {
            //     hasVideo = true
            //   }
            // }
            let array = []
            for (let i = 0; i < this.allRightDraftList.length; i++) {
              // if (this.allRightDraftList[i].content.indexOf('<video') >= 0) {
              //   hasVideo = true
              // }
              array.push(this.allRightDraftList[i].id)
            }
            let flag = await this.$axiox.asyncPost('/api/push/push/ishasvideo', array)
            if (flag) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '含有待腾讯审核的视频内容，已通知管理员，请稍后再试',
                stayTime: 5
              })
              return
            }
          }
          if (data.pushtypeId === 1) {
            if (data.content === '') {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '请输入文本内容',
                stayTime: 5
              })
              return
            }
          }
          if (data.pushtypeId === 2) {
            if (!data.fileid) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '失败',
                content: '请上传图片',
                stayTime: 5
              })
              return
            }
          }
          console.log(data, 'data')
          console.log(this.allRightDraftList, 'this.allRightDraftList')
          this.$axiox.post('/api/push/pubtexttest', data).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '发送成功!',
              stayTime: 5
            })
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择至少一位接收人',
            stayTime: 5
          })
        }
      } else {
        console.log(e.chooseUserList)
        console.log(this.postData.puspoelple)
        let list = []
        if (this.postData.publishNow) {
          list = this.$commonJs.conbinedistinct(e.chooseUserList, this.postData.puspoelple, 'openId')
          console.log(list)

          this.postData.puspoelple = list

          // let emailList = []
          for (let i = 0; i < this.postData.puspoelple.length; i++) {
            this.postData.puspoelple[i].nickName = this.postData.puspoelple[i].docName
            this.postData.puspoelple[i].openID = this.postData.puspoelple[i].openId
            this.postData.puspoelple[i].OpenID = this.postData.puspoelple[i].openId
          }
        } else {
          e.chooseUserList.forEach(item => {
            if (item.openID) {
              item.openId = item.openID
            }
          })
          let openIdList = this.postData.puspoelple.map(x => x.openID)
          let newEl = []

          for (let j = 0; j < e.chooseUserList.length; j++) {
            if (openIdList.indexOf(e.chooseUserList[j]['openId']) < 0) {
              newEl.push(_.cloneDeep(e.chooseUserList[j]))
              e.chooseUserList.splice(j, 1)
              j--
            }
          }

          list = newEl.concat(e.chooseUserList)
          this.postData.puspoelple = list

          for (let i = 0; i < this.postData.puspoelple.length; i++) {
            this.postData.puspoelple[i].nickName = this.postData.puspoelple[i].docName ? this.postData.puspoelple[i].docName : this.postData.puspoelple[i].nickName
            this.postData.puspoelple[i].openID = this.postData.puspoelple[i].openId
            this.postData.puspoelple[i].OpenID = this.postData.puspoelple[i].openId
          }
        }
      }
        //   emailList.push(e.chooseUserList[i])
        // }
    },
    returnPushType (pushType) {
      if (pushType === 1) {
        return '文本'
      }
      if (pushType === 2) {
        return '图片消息'
      }
      if (pushType === 3) {
        return '图文消息'
      }
    },
    async SubmitList () {
      let status = await this.getGroupDetail()
      let toService = JSON.parse(JSON.stringify(this.postData))
      if (toService.publishNow) {
        toService.pushPlanTime = ''
      }
      toService.messageContentMappings = []
      if (this.allRightDraftList.length === 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请选择内容',
          stayTime: 5
        })
        return
      }
      if (this.postData.groupId === '' || (this.isCanLike === false && this.isCanComment === false && this.isCanShare === false && this.hasWatermark === false)) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请检查必填项',
          stayTime: 5
        })
        return
      }
      for (let i = 0; i < this.allRightDraftList.length; i++) {
        let data = {
          contentId: this.allRightDraftList[i].detailInfo.id,
          orderIndex: i
        }
        toService.messageContentMappings.push(data)
      }
      this.$axiox.put('/api/content/publish/' + this.messagePublishId, toService).then(p => {
        console.log(status)
        if (status.adminList.length === 0) {
          this.$commonJs.doubleComfirm({
            content: '该组目前没有组管理员，是否确定提交审批？',
            successFun: msg => {
              this.secSubmitList()
            },
            errorFun: msg => {
            }
          })
        } else {
          this.secSubmitList()
        }
      })
    },
    async secSubmitList () {
      let status = await this.getContentTypeDetail()
      console.log(status)
      if (status.owners.length === 0) {
        this.$commonJs.doubleComfirm({
          content: '该类型目前没有管理员，是否确定提交审批？',
          successFun: msg => {
            this.$axiox.put('/api/content/publish/' + this.newMessagePublishId + '/submit').then(msg => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '提交成功!',
                stayTime: 5
              })
              this.$router.push({
                name: 'ContentRelease'
              })
              // this.$router.history.go(-1)
            })
          },
          errorFun: msg => {
          }
        })
      } else {
        this.$axiox.put('/api/content/publish/' + this.newMessagePublishId + '/submit').then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '提交成功!',
            stayTime: 5
          })
          this.$router.push({
            name: 'ContentRelease'
          })
          // this.$router.history.go(-1)
        })
      }
    },
    getGroupDetail () {
      return new Promise((resolve, reject) => {
        this.$axiox.get('/api/Group/' + this.postData.groupId).then(msg => {
          resolve(msg.result)
        })
      })
    },
    getContentTypeDetail () {
      return new Promise((resolve, reject) => {
        this.$axiox.get('/api/contentType/' + this.$route.query.selectContentType).then(msg => {
          resolve(msg.result)
        })
      })
    },
    selLaud () {
      this.showModel.model5 = true
      this.newReview = {
        reviewAction: true,
        reviewComment: ''
      }
    },
    addNewMaterial () {
      // this.getmyDraftList(1)
      this.showModel.model6 = true
      this.newMyDraf = []
      this.myDraftList = JSON.parse(JSON.stringify(this.allRightDraftList))
      for (let i = 0; i < this.myDraftList.length; i++) {
        this.myDraftList[i]['checked'] = false
        this.myDraftList[i]['materialScope'] = 'AllUser'
      }
      console.log(this.myDraftList)
    },
    // 保存为素材
    materialModel () {
      // if (!this.checkedNum) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '失败',
      //     content: '请选择内容!',
      //     stayTime: 5
      //   })
      //   return
      // }
      let num = 0
      for (let i = 0; i < this.myDraftList.length; i++) {
        if (this.myDraftList[i].checked) {
          num++
          let list = {
            contentId: this.myDraftList[i].detailInfo.id,
            materialScope: this.myDraftList[i].materialScope
          }
          this.newMyDraf.push(list)
        }
      }
      if (num > 0) {
        let data = {
          materialItems: this.newMyDraf,
          tag: this.newTag
        }
        this.$axiox.post('/api/content/materials', data).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '提交成功!',
            stayTime: 5
          })
          this.showModel.model6 = false
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择内容!',
          stayTime: 5
        })
      }
    },
    moveUp (item, index) {
      if (this.messageState == '已推送') {
        return
      }
      if (index == 0) {
        return
      }
      let tempArtical = this.allRightDraftList[index - 1]
      this.allRightDraftList[index - 1] = item
      this.allRightDraftList[index] = tempArtical
      this.$forceUpdate()
    },
    moveDown (item, index) {
      if (this.messageState == '已推送') {
        return
      }
      if (index == this.allRightDraftList.length - 1) {
        return
      }
      let tempArtical = this.allRightDraftList[index + 1]
      this.allRightDraftList[index + 1] = item
      this.allRightDraftList[index] = tempArtical
      this.$forceUpdate()
    },
  }
  // computed: {
  //   checkedNum () {
  //     let num = 0
  //     for (let i = 0; i < this.myDraftList.length; i++) {
  //       if (this.myDraftList[i].checked) {
  //         num++
  //       }
  //     }
  //     if (num > 0) {
  //       return false
  //     } else {
  //       return true
  //     }
  //   }
  // }
}
</script>

<style scoped>
  tr.choosed td{
    background: #FF7F41;
    color: #fff;
  }
  #modelSwitah{
    padding:0 10px;
    overflow: hidden;
  }
  @media screen and (max-width: 1370px) {
    .textlist {
      width: 45%;
    }
    .textlist:after {
      left: 10.5%;
    }
    /*.textlist2:after {*/
    /*  left: 10.5%!important;*/
    /*}*/
    .textlist2:before {
      left: 8.8%!important;
    }
    .laudTop {
      padding-top: 2%;
    }
  }
  .move-btn {
    width: 35px;
    padding: 5px 0;
    text-align: center;
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
  }
  .enable-move {
    font-size:26px;
    color: #ee9900;
  }
  .disable-move {
    color: #DCDCDC;
    cursor: not-allowed;
  }
  .liCover{
    position: relative;
  }
  .liCover::after {
    content: '已下架';
    color: #fff;
    text-align: center;
    padding-top: 30px;
    box-sizing: border-box;
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/ContentReleaseList.vue